import React from 'react'
import './Footer.css'
import SocialLinks from './SocialLinks/SocialLinks'

function Footer() {
	return (
		<>
			<footer className="footer">
				<div className="container-fluid">
					<div className="row">
						<h3>&copy; All rights reserved by Khoj</h3>
						<h3>Made with ❤ by  <a href="https://theantopolis.com/">Antopolis</a></h3>
					</div>
				</div>
				<SocialLinks />
			</footer>
		</>
	)
}

export default Footer